/**
 * Web Push subscription helper.
 * The service worker is registered separately in /lib/pwa.js.
 */
import api from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

function arrayBufferToBase64Url(buf) {
  const bytes = new Uint8Array(buf);
  let str = "";
  for (let i = 0; i < bytes.byteLength; i++) str += String.fromCharCode(bytes[i]);
  return window.btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function pushPermission() {
  return typeof Notification !== "undefined" ? Notification.permission : "denied";
}

export async function getCurrentSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function subscribePush() {
  if (!isPushSupported()) throw new Error("Push non supportato dal browser");
  const reg = await navigator.serviceWorker.ready;
  // Get VAPID public key from server
  const { data } = await api.get("/push/vapid-public-key");
  const applicationServerKey = urlBase64ToUint8Array(data.key);
  // Request permission and subscribe
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permesso notifiche negato");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  });
  const raw = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: raw.endpoint,
    p256dh: raw.keys?.p256dh || arrayBufferToBase64Url(sub.getKey("p256dh")),
    auth: raw.keys?.auth || arrayBufferToBase64Url(sub.getKey("auth")),
    user_agent: navigator.userAgent,
  });
  return sub;
}

export async function unsubscribePush() {
  const sub = await getCurrentSubscription();
  if (!sub) return false;
  try {
    await api.delete("/push/subscribe", { params: { endpoint: sub.endpoint } });
  } catch (e) {
    console.warn("Push server-side unsubscribe failed (non-blocking):", e?.message || e);
  }
  await sub.unsubscribe();
  return true;
}

export async function sendTestPush() {
  return api.post("/push/test");
}
